import { Component, Input, computed } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICONS } from '../icons';

@Component({
  selector: 'app-icon',
  standalone: true,
  template: `
    <span
      class="inline-flex w-full h-full text-current"
      [innerHTML]="svg()"
    ></span>
  `,
  
})
export class IconComponent {
  @Input({ required: true }) name!: keyof typeof ICONS;

  constructor(private sanitizer: DomSanitizer) {}

  svg = computed<SafeHtml>(() => {
    const icon = ICONS[this.name];
    return this.sanitizer.bypassSecurityTrustHtml(icon);
  });
}
